var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionsList',{attrs:{"items":_vm.sectionsItems,"page-name":'Home',"fullscreen":"","preload-media":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }